import { PlusOutlined } from '@ant-design/icons'
import './ObjectBrowseField.css'

type Props = {
  name?: string
  placeholder?: string
  disabled?: boolean
  required?: boolean
  onBrowse: () => void
  className?: string
  ariaLabel?: string
}

export function ObjectBrowseField({
  name,
  placeholder = '请选择',
  disabled,
  required = true,
  onBrowse,
  className,
  ariaLabel = '浏览选择',
}: Props) {
  const open = () => {
    if (!disabled) onBrowse()
  }

  return (
    <div
      className={[
        'object-browse-field',
        name ? '' : 'is-empty',
        disabled ? 'is-disabled' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={open}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          open()
        }
      }}
      role="button"
      tabIndex={disabled ? -1 : 0}
    >
      {name ? (
        <span className="object-browse-field-name">{name}</span>
      ) : (
        <span className="object-browse-field-placeholder">{placeholder}</span>
      )}
      <button
        type="button"
        className="object-browse-field-add"
        onClick={(e) => {
          e.stopPropagation()
          open()
        }}
        disabled={disabled}
        aria-label={ariaLabel}
      >
        <PlusOutlined />
      </button>
      {required ? <span className="object-browse-field-required">*</span> : null}
    </div>
  )
}

/** 嵌套在文件夹设置等 Modal 内时，浏览弹窗需更高 z-index */
export const BROWSE_PICKER_Z_INDEX = 1100
